export default __webpack_public_path__ + "static/media/IMG_9975.555f2815.webp";